<template>
  <div
    id="contact"
    v-if="this.$vuetify.breakpoint.mdAndUp"
    class="d-flex justify-center"
  >
    <v-col cols=" 6 " class="d-flex justify-center mt-2 headRow">
      <h3
        id="head"
        class="hideOverflow"
        data-aos="fade-right"
        data-aos-duration="1000"
        style="margin-top:48px;"
      >
        Get in Touch
      </h3>
    </v-col>
    <v-col cols=" 6 " class="mt-8 pt-8">
      <v-form
        ref="form"
        v-model="valid"
        method="post"
        action="https://formspree.io/mrgydvzy"
        id="contactForm"
        name="contactForm"
      >
        <v-row style="margin-left:0.5px; margin-right:2px">
          <v-col
            cols="12"
            sm="6"
            class="hideOverflow"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <v-text-field
              v-model="name"
              :rules="nameRules"
              dark
              label="Name"
              name="name"
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="hideOverflow"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <v-text-field
              v-model="email"
              :rules="emailRules"
              dark
              label="Email"
              name="_replyto"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-col
          cols="12"
          class="hideOverflow"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <!-- <v-text-field label="Message" outlined></v-text-field> -->
          <v-textarea
            v-model="msg"
            :rules="msgRules"
            dark
            outlined
            label="Message"
            name="message"
          ></v-textarea>
        </v-col>
        <v-btn
          id="sendbtn"
          class="ml-3 mr-4 hideOverflow"
          dark
          outlined
          @click="validate"
          data-aos="fade-left"
          data-aos-duration="1000"
          >Send Message
        </v-btn>
        <v-btn
          color="error"
          outlined
          class="mr-4 hideOverflow"
          @click="reset"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          Reset Form
        </v-btn>

        <v-btn
          color="warning"
          outlined
          @click="resetValidation"
          class="hideOverflow"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          Reset Validation
        </v-btn>
      </v-form>
    </v-col>
  </div>
  <div v-else id="contactMobile">
    <v-row justify="center" style="margin:0;">
      <h3
        id="head"
        class="hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
        style="margin-top:48px;margin-bottom:48px;"
      >
        Get in Touch
      </h3>
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      method="post"
      action="https://formspree.io/mrgydvzy"
      id="contactForm"
      name="contactForm"
    >
      <v-row
        class="formRow hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <v-text-field
          v-model="name"
          :rules="nameRules"
          dark
          label="Name"
          style="overflow-x:hidden;"
          name="name"
          outlined
        ></v-text-field>
      </v-row>
      <v-row
        class="formRow hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <v-text-field
          v-model="email"
          :rules="emailRules"
          dark
          label="Email"
          style="overflow-x:hidden;"
          name="_replyto"
          outlined
        ></v-text-field>
      </v-row>
      <v-row
        class="formRow hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <!-- <v-text-field label="Message" outlined></v-text-field> -->
        <v-textarea
          v-model="msg"
          :rules="msgRules"
          dark
          outlined
          style="overflow-x:hidden;"
          label="Message"
          name="message"
        ></v-textarea>
      </v-row>
      <v-row style="margin:0;">
        <v-col cols="6" class="d-flex justify-center">
          <v-btn
            id="sendbtn"
            class="hideOverflow"
            dark
            outlined
            @click="validate"
            data-aos="fade-up"
            data-aos-duration="1000"
            style="margin-left:40px"
            >Send Message
          </v-btn>
        </v-col>
        <v-col cols="6" class="d-flex justify-center">
          <v-btn
            color="error"
            outlined
            class="hideOverflow"
            @click="reset"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            Reset Form
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" style="margin:0;">
        <v-btn
          color="warning"
          outlined
          @click="resetValidation"
          class="hideOverflow"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          Reset Validation
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data: () => ({
    valid: false,
    name: "",
    nameRules: [v => !!v || "Name is required"],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid"
    ],
    msg: "",
    msgRules: [v => !!v || "Message is required"]
  }),
  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.valid) document.contactForm.submit();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>
<style scoped>
#contact {
  background-color: #333646;
  height: 550px;
}
#head {
  color: #999aa2;

  font-family: "Gilroy Regular";
  font-size: 2.5rem;
}
</style>
<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@media #{map-get(
    $display-breakpoints,
    "sm-and-down"
  )} {
  .hideOverflow {
    overflow-x: hidden;
  }
  .formRow {
    margin: 0 40px 0 40px;
  }
  #contactMobile {
    background-color: #333646;
    height: 750px;
  }
}
@font-face {
  font-family: "Gilroy Bold";
  src: url("../assets/fonts/Gilroy-Bold.eot");
  src: url("../assets/fonts/Gilroy-Bold.eot?#iefix") format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Bold.woff") format("woff"),
    url("../assets/fonts/Gilroy-Bold.otf") format("opentype"),
    url("../assets/fonts/Gilroy-Bold.ttf") format("truetype"),
    url("../assets/fonts/Gilroy-Bold.svg") format("svg");
}
@font-face {
  font-family: "Gilroy SemiBold";
  src: url("../assets/fonts/Gilroy-SemiBold.eot");
  src: url("../assets/fonts/Gilroy-SemiBold.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-SemiBold.woff") format("woff"),
    url("../assets/fonts/Gilroy-SemiBold.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Medium";
  src: url("../assets/fonts/Gilroy-Medium.eot");
  src: url("../assets/fonts/Gilroy-Medium.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Medium.woff") format("woff"),
    url("../assets/fonts/Gilroy-Medium.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Regular";
  src: url("../assets/fonts/Gilroy-Regular.eot");
  src: url("../assets/fonts/Gilroy-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Regular.woff") format("woff"),
    url("../assets/fonts/Gilroy-Regular.otf") format("opentype");
}
</style>
